<template>
  <div class="log-tree-container">
    <div class="header">
      <h3>服务日志树形列表</h3>
      <el-input
          v-model="filterText"
          placeholder="输入关键字过滤"
          clearable
          style="width: 300px; margin-bottom: 20px;"
      />
    </div>

    <div class="tree-wrapper">
      <el-tree
          ref="treeRef"
          node-key="id"
          :props="treeProps"
          :load="loadNode"
          :filter-node-method="filterNode"
          lazy
          :highlight-current="true"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeCollapse"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span :class="getNodeIcon(node, data)" class="">
            {{ node.label }}
          </span>

          <!-- 显示节点信息 -->
          <span v-if="data.type === 'service'" class="node-info">
            (IP数量: {{ data.ipCount || '加载中...' }})
          </span>

          <span v-if="data.type === 'ip'" class="node-info">
            (日志数: {{ data.totalLogs || '加载中...' }})
          </span>

          <!-- 分页信息 -->
          <span v-if="data.type === 'log-page' && data.logs" class="pagination-info">
            ({{ data.currentPage }}/{{ data.totalPages }})
          </span>
        </span>
      </el-tree>
    </div>

    <!-- 节点详情面板 -->
    <div v-if="selectedNode" class="detail-panel">
      <h4>节点详情</h4>
      <div class="detail-content">
        <p><strong>名称:</strong> {{ selectedNode.name }}</p>
        <p><strong>类型:</strong> {{ getNodeTypeText(selectedNode.type) }}</p>
        <p v-if="selectedNode.type === 'service'">
          <strong>服务描述:</strong> {{ selectedNode.description || '暂无描述' }}
        </p>
        <p v-if="selectedNode.type === 'ip'">
          <strong>服务器地址:</strong> {{ selectedNode.address || selectedNode.name }}
        </p>
        <p v-if="selectedNode.type === 'log'">
          <strong>文件大小:</strong> {{ selectedNode.size || '未知' }}
          <br>
          <strong>最后修改:</strong> {{ selectedNode.lastModified || '未知' }}
        </p>
      </div>
      <el-button
          v-if="selectedNode.type === 'log'"
          type="primary"
          size="small"
          @click="viewLog(selectedNode)"
      >
        查看日志
      </el-button>
    </div>

    <!-- 加载中遮罩 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-content">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogTreeWithPagination',
  data() {
    return {
      filterText: '',
      loading: false,
      selectedNode: null,

      // 树配置
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf'
      },

      // 模拟数据存储
      dataStore: {
        // 服务列表
        services: [
          { id: 'service-1', name: '订单服务', description: '处理订单相关业务', ipCount: 3 },
          { id: 'service-2', name: '用户服务', description: '用户认证与管理', ipCount: 2 },
          { id: 'service-3', name: '支付服务', description: '支付处理与对账', ipCount: 4 },
          { id: 'service-4', name: '商品服务', description: '商品信息与库存管理', ipCount: 1 }
        ],

        // IP列表：serviceId -> IP数组
        ipMap: {
          'service-1': [
            { id: 'ip-1-1', name: '192.168.1.101', totalLogs: 156, address: '北京数据中心-1' },
            { id: 'ip-1-2', name: '192.168.1.102', totalLogs: 203, address: '北京数据中心-2' },
            { id: 'ip-1-3', name: '192.168.1.103', totalLogs: 89, address: '上海数据中心-1' }
          ],
          'service-2': [
            { id: 'ip-2-1', name: '192.168.2.101', totalLogs: 312, address: '广州数据中心-1' },
            { id: 'ip-2-2', name: '192.168.2.102', totalLogs: 178, address: '深圳数据中心-1' }
          ],
          'service-3': [
            { id: 'ip-3-1', name: '192.168.3.101', totalLogs: 267, address: '杭州数据中心-1' },
            { id: 'ip-3-2', name: '192.168.3.102', totalLogs: 145, address: '杭州数据中心-2' },
            { id: 'ip-3-3', name: '192.168.3.103', totalLogs: 98, address: '成都数据中心-1' },
            { id: 'ip-3-4', name: '192.168.3.104', totalLogs: 221, address: '武汉数据中心-1' }
          ],
          'service-4': [
            { id: 'ip-4-1', name: '192.168.4.101', totalLogs: 134, address: '西安数据中心-1' }
          ]
        },

        // 日志数据：ipId -> 日志数组（模拟大量数据）
        logMap: {}
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.treeRef.filter(val)
    }
  },
  mounted() {
    this.initLogData()
    console.log('日志树组件已初始化')
  },
  methods: {
    // 初始化日志数据
    initLogData() {
      // 为每个IP生成模拟日志数据
      Object.values(this.dataStore.ipMap).forEach(ipList => {
        ipList.forEach(ip => {
          const logCount = ip.totalLogs || 0
          const logs = []

          for (let i = 1; i <= logCount; i++) {
            const size = Math.floor(Math.random() * 1024 * 1024) + 1024 // 1KB - 1MB
            const date = new Date()
            date.setDate(date.getDate() - Math.floor(Math.random() * 30)) // 30天内

            logs.push({
              id: `${ip.id}-log-${i}`,
              name: `server_log_${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(i).padStart(3, '0')}.log`,
              type: 'log',
              leaf: true,
              size: this.formatFileSize(size),
              lastModified: date.toLocaleDateString()
            })
          }

          this.dataStore.logMap[ip.id] = logs
        })
      })
    },

    // 树节点懒加载
    async loadNode(node, resolve) {
      try {
        this.loading = true

        // 模拟网络延迟
        await new Promise(resolve => setTimeout(resolve, 300))

        let data = []

        if (node.level === 0) {
          // 第一层：服务列表
          data = this.dataStore.services.map(service => ({
            ...service,
            type: 'service',
            leaf: false
          }))
        } else if (node.level === 1) {
          // 第二层：IP地址列表
          const serviceId = node.data.id
          const ips = this.dataStore.ipMap[serviceId] || []

          data = ips.map(ip => ({
            ...ip,
            type: 'ip',
            leaf: false
          }))
        } else if (node.level === 2) {
          // 第三层：日志文件分页加载
          const ipId = node.data.id
          const allLogs = this.dataStore.logMap[ipId] || []

          // 获取当前页码
          const pageNum = node.data.currentPage || 1
          const pageSize = 10
          const total = allLogs.length
          const totalPages = Math.ceil(total / pageSize)
          const start = (pageNum - 1) * pageSize
          const end = start + pageSize

          // 当前页的日志
          const currentLogs = allLogs.slice(start, end)

          // 构建节点数据
          data = currentLogs.map(log => ({
            ...log,
            leaf: true
          }))

          // 如果还有更多日志，添加"加载更多"节点
          if (pageNum < totalPages) {
            data.push({
              id: `${ipId}-page-${pageNum + 1}`,
              name: '加载更多...',
              type: 'log-page',
              leaf: false,
              ipId: ipId,
              currentPage: pageNum + 1,
              totalPages: totalPages,
              logs: allLogs,
              isLoadMore: true
            })
          }

          // 如果这是第一页，添加一个父节点信息
          if (pageNum === 1 && total > 0) {
            data.unshift({
              id: `${ipId}-info`,
              name: `日志列表 (共 ${total} 个文件)`,
              type: 'log-info',
              leaf: true,
              isInfo: true
            })
          }
        }

        resolve(data)
      } catch (error) {
        console.error('加载节点失败:', error)
        resolve([])
      } finally {
        this.loading = false
      }
    },

    // 节点点击事件
    handleNodeClick(data, node) {
      this.selectedNode = data

      // 如果是"加载更多"节点
      if (data.isLoadMore) {
        // 重新加载父节点（IP节点）以获取下一页数据
        node.parent.loaded = false
        node.parent.loadData()
      }

      // 如果是日志节点，可以选择展开详情
      if (data.type === 'log') {
        console.log('点击日志文件:', data.name)
      }
    },

    // 节点展开事件
    handleNodeExpand(data, node) {
      console.log('展开节点:', data.name)
    },

    // 节点折叠事件
    handleNodeCollapse(data, node) {
      console.log('折叠节点:', data.name)
    },

    // 节点过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.toLowerCase().includes(value.toLowerCase())
    },

    // 根据节点类型获取图标类名
    getNodeIcon(node, data) {
      const baseClass = 'node-icon'

      if (data.type === 'service') {
        return `${baseClass} service-icon`
      } else if (data.type === 'ip') {
        return `${baseClass} ip-icon`
      } else if (data.type === 'log') {
        return `${baseClass} log-icon`
      } else if (data.isLoadMore) {
        return `${baseClass} loadmore-icon`
      } else if (data.isInfo) {
        return `${baseClass} info-icon`
      }

      return baseClass
    },

    // 获取节点类型文本
    getNodeTypeText(type) {
      const typeMap = {
        'service': '服务',
        'ip': 'IP地址',
        'log': '日志文件',
        'log-page': '分页控制',
        'log-info': '信息提示'
      }
      return typeMap[type] || '未知'
    },

    // 查看日志内容
    viewLog(logNode) {
      console.log('查看日志:', logNode.name)
      // 这里可以调用API获取日志内容并显示
      this.$alert(`正在打开日志文件: ${logNode.name}\n文件大小: ${logNode.size}`, '日志查看', {
        confirmButtonText: '确定',
        callback: action => {
          // 可以在这里添加实际查看日志的逻辑
        }
      })
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  }
}
</script>

<style scoped>
.log-tree-container {
  display: flex;
  height: 700px;
  padding: 20px;
  background-color: #f5f7fa;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

.header {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
}

.header h3 {
  margin-bottom: 15px;
  color: #303133;
  font-weight: 500;
}

.tree-wrapper {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  margin-right: 20px;
  margin-top: 80px;
}

.detail-panel {
  width: 280px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 80px;
}

.detail-panel h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #409eff;
  font-weight: 500;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.detail-content {
  margin-bottom: 20px;
}

.detail-content p {
  margin: 8px 0;
  color: #606266;
  font-size: 14px;
}

.detail-content strong {
  color: #303133;
  margin-right: 5px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.node-icon {
  display: inline-block;
  margin-right: 8px;
  width: 16px;
  text-align: center;
}

.service-icon::before {
  content: "📁";
}

.ip-icon::before {
  content: "🖥️";
}

.log-icon::before {
  content: "📄";
}

.loadmore-icon::before {
  content: "⬇️";
}

.info-icon::before {
  content: "ℹ️";
}

.node-info {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}

.pagination-info {
  font-size: 12px;
  color: #67c23a;
  margin-left: 8px;
  font-weight: 500;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.loading-content .el-icon-loading {
  font-size: 40px;
  margin-bottom: 10px;
  color: #409eff;
}

/* 自定义树节点悬停效果 */
:deep(.el-tree-node__content:hover) {
  background-color: #f5f7fa;
}

:deep(.el-tree-node:focus > .el-tree-node__content)  {
  background-color: #ecf5ff;
}

/* 调整树节点展开/折叠图标 */
:deep(.el-tree-node__expand-icon) {
  color: #c0c4cc;
  font-size: 16px;
}

:deep(.el-tree-node__expand-icon.is-leaf) {
  color: transparent;
  cursor: default;
}
</style>
